// 处理用户信息
class UserTool {
  /**
   判断用户是否存该权限
   @param {String} name 权限名称
   @return {Boolean} 是否存在
  */

  isAccept (name) {
    let authority = JSON.parse(sessionStorage.getItem("permList"));
    let result = false;
    function check (array) {
      array.forEach(item => {
        if(item.permName === name){
          result =  true
        } else if (item.listPerm && item.listPerm.length > 0){
          check(item.listPerm)
        }
      })
    }
    check(authority)
    return result;
  }

}
export default new UserTool();



// WEBPACK FOOTER //
// ./src/assets/js/permisson.js